/**
 * Registers the 'ibGroupedBarChart' directive with the provided directives collection.
 * This directive is used to create a grouped bar chart using D3 and NVD3 libraries.
 * 
 * @param {Object} directives - The collection of directives to which the 'ibGroupedBarChart' directive will be added.
 */
export default function registerIbGroupedBarChartDirective(directives) {
    directives.directive('ibGroupedBarChart', ['$window', '$timeout',
        function ($window, $timeout) {
            return {
                restrict: 'E', // Restricts the directive to element usage only.
                scope: {
                    chartData: '=data', // Binds the chart data to the directive's scope.
                    yLabel: '=yLabel', // Binds the Y-axis label to the directive's scope.
                    xLabel: '=xLabel', // Binds the X-axis label to the directive's scope.
                    title: '=title' // Binds the chart title to the directive's scope.
                },
                link: function (scope, element) {
                    /**
                     * Watches for changes in the chartData and reinitializes the chart if changes are detected.
                     */
                    scope.$watch('chartData', function () {
                        init();
                    });

                    /**
                     * Watches for changes in the yLabel and reinitializes the chart if changes are detected.
                     */
                    scope.$watch('yLabel', function () {
                        init();
                    });

                    /**
                     * Initializes the chart with the current data and labels.
                     */
                    function init() {
                        if (typeof (scope.chartData) !== 'undefined' && scope.chartData.length >= 1) {
                            $window.nv.addGraph(function () {
                                var chart = $window.nv.models.multiBarChart()
                                    .reduceXTicks(true)   // If 'false', every single x-axis tick label will be rendered.
                                    .rotateLabels(0)      // Angle to rotate x-axis labels.
                                    .showControls(false)   // Allow user to switch between 'Grouped' and 'Stacked' mode.
                                    .groupSpacing(0.1)    // Distance between each group of bars.
                                    .stacked(false)
                                    .color(["#1f77b4", "#B10DC9", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"]);

                                chart.yAxis
                                    .tickFormat(d3.format(',.3f'))
                                    .axisLabel(scope.yLabel);

                                chart.xAxis
                                    .axisLabel(scope.xLabel);

                                // SMELL: This loop overrides all event handlers of the legend, potentially disabling useful functionality.
                                for (var property in chart.legend.dispatch) {
                                    chart.legend.dispatch[property] = function () { };
                                }

                                $window.d3.select(element[0].querySelector('svg'))
                                    .datum(scope.chartData)
                                    .call(chart);

                                $window.nv.utils.windowResize(chart.update);

                                return chart;
                            });
                        }
                    }

                    init();
                }
            };
        }
    ]);
}